const STORAGE_KEY = 'aniimo.device';

/**
 * Random id so one browser counts once per code. Nothing about it is derived
 * from the person. Private-mode browsers can refuse storage, in which case it
 * lasts for the session only and voting still works.
 */
export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;

    const created = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return (sessionDeviceId ??= crypto.randomUUID());
  }
}

let sessionDeviceId: string | undefined;

const VOTES_KEY = 'aniimo.votes';

/** Which way this browser has already voted, so the UI can show it. */
export function readVotes(): Record<string, 'works' | 'fails'> {
  try {
    const raw = localStorage.getItem(VOTES_KEY);
    return raw ? (JSON.parse(raw) as Record<string, 'works' | 'fails'>) : {};
  } catch {
    return {};
  }
}

export function rememberVote(codeId: string, vote: 'works' | 'fails'): void {
  try {
    localStorage.setItem(VOTES_KEY, JSON.stringify({ ...readVotes(), [codeId]: vote }));
  } catch {
    // Storage is a convenience here; the server still records the vote.
  }
}
